<!-- RegisterEntry.vue -->
<template>
  <div class="register-entry-config">
    <!-- 头部操作栏 -->
    <div class="header">
      <h1>报名入口管理</h1>
      <div class="header-actions">
        <button class="btn save-btn" @click="saveConfig" :disabled="isSaving">
          {{ isSaving ? '保存中...' : '保存配置' }}
        </button>
      </div>
    </div>

    <!-- 配置编辑区域 -->
    <div class="config-editor">
      <!-- 板块基础信息 -->
      <div class="config-section">
        <div class="section-header">
          <h2>板块基础信息</h2>
        </div>
        <div class="section-content">
          <div class="form-group">
            <label>板块标题</label>
            <input type="text" v-model="sectionData.title" placeholder="请输入板块标题">
          </div>
          <div class="form-group">
            <label>板块描述</label>
            <textarea v-model="sectionData.desc" placeholder="请输入板块描述"></textarea>
          </div>
        </div>
      </div>
      <!-- 公众号/专栏入口配置 -->
      <div class="config-section">
        <div class="section-header">
          <h2>公众号/专栏入口</h2>
        </div>
        <div class="section-content">
          <div class="form-group">
            <label>公众号/专栏列表</label>
            <div class="channel-list">
              <div
                  v-for="(channel, index) in configData.data.sections.find(s => s.id === 'register').data.channelBtns"
                  :key="index"
                  class="channel-item"
              >
                <input
                    type="text"
                    v-model="configData.data.sections.find(s => s.id === 'register').data.channelBtns[index]"
                    placeholder="请输入公众号/专栏名称"
                    class="channel-input"
                />
                <button
                    class="remove-btn"
                    @click="removeChannel(index)"
                    v-if="configData.data.sections.find(s => s.id === 'register').data.channelBtns.length > 1"
                >
                  删除
                </button>
              </div>
              <button class="add-btn" @click="addChannel">添加公众号/专栏</button>
            </div>
          </div>
        </div>
      </div>

      <!-- 报名类型按钮配置 -->
<!--      <div class="config-section">
        <div class="section-header">
          <h2>报名类型按钮</h2>
        </div>
        <div class="section-content">
          <div
              v-for="(entry, index) in configData.data.sections.find(s => s.id === 'register').data.entryBtns"
              :key="index"
              class="entry-item"
          >
            <div class="form-group">
              <label>按钮类型</label>
              <input
                  type="text"
                  v-model="configData.data.sections.find(s => s.id === 'register').data.entryBtns[index].type"
                  placeholder="请输入按钮类型"
              />
            </div>
            <div class="form-group">
              <label>按钮图标</label>
              <input
                  type="text"
                  v-model="configData.data.sections.find(s => s.id === 'register').data.entryBtns[index].icon"
                  placeholder="请输入按钮图标字符"
              />
            </div>
            <button
                class="remove-entry-btn"
                @click="removeEntry(index)"
                v-if="configData.data.sections.find(s => s.id === 'register').data.entryBtns.length > 1"
            >
              删除此按钮
            </button>
          </div>
          <button class="add-btn" @click="addEntry">添加报名类型按钮</button>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { getBanner, updateBannerApi } from '@/api/website'

// 配置数据
const configData = ref({
  id: 0,
  data: {
    sections: [
      {
        id: "register",
        title: "06 报名入口",
        desc: "填写信息，开启你的星途之旅",
        component: "RegisterForm",
        data: {
          // 公众号/专栏入口
          channelBtns: [
            "星途杯公众号",
            "娱乐世界星途杯专栏"
          ],
          // 报名类型按钮
          entryBtns: [
            { type: "选手报名", icon: "🎤" },
            { type: "机构报名", icon: "🏢" },
            { type: "合作报名", icon: "🤝" }
          ]
        }
      }
    ]
  }
})

// 板块数据
const sectionData = ref({
  title: "06 报名入口",
  desc: "填写信息，开启你的星途之旅"
})

const isSaving = ref(false)
const allConfig = ref({}) // 添加这一行，保存完整的配置数据

// 加载配置
const loadWebsiteConfig = async () => {
  try {
    const response = await getBanner({"adminId":1})
    if (response.data && response.data.data) {
      console.log('获取配置成功:', response.data.data)
      // 保存完整配置
      allConfig.value = response.data.data
      // 查找报名入口配置
      const registerSection = allConfig.value.data.sections.find(s => s.id === 'register')
      if (registerSection) {
        configData.value.id = response.data.data.id
        configData.value.data.sections[0] = registerSection
        // 同步更新板块基础信息
        sectionData.value.title = registerSection.title
        sectionData.value.desc = registerSection.desc
      }
    }
  } catch (error) {
    console.error('加载配置失败:', error)
    alert('加载配置失败，请重试')
  }
}

// 保存配置
const saveConfig = async () => {
  try {
    isSaving.value = true

    // 同步板块基础信息到配置数据
    const registerSection = configData.value.data.sections.find(s => s.id === 'register')
    registerSection.title = sectionData.value.title
    registerSection.desc = sectionData.value.desc

    // 更新完整配置中的register板块数据
    const sectionIndex = allConfig.value.data.sections.findIndex(section => section.id === "register")
    if (sectionIndex !== -1) {
      allConfig.value.data.sections[sectionIndex] = {...registerSection}
    }

    // 查找并更新导航栏中指向#register的链接标题
    const navSection = allConfig.value.data.sections.find(section => section.id === "nav")
    if (navSection) {
      const registerNavItem = navSection.data.find(item => item.link === "#register")
      if (registerNavItem) {
        registerNavItem.label = sectionData.value.title
      }
    }

    // 构造保存数据，使用完整配置
    const saveData = {
      id: configData.value.id,
      data: allConfig.value.data
    }

    await updateBannerApi(saveData)
    alert('保存成功！')
  } catch (error) {
    console.error('保存配置失败:', error)
    alert('保存失败，请重试')
  } finally {
    isSaving.value = false
  }
}

// 添加公众号/专栏
const addChannel = () => {
  const registerSection = configData.value.data.sections.find(s => s.id === 'register')
  registerSection.data.channelBtns.push("")
}

// 删除公众号/专栏
const removeChannel = (index) => {
  const registerSection = configData.value.data.sections.find(s => s.id === 'register')
  registerSection.data.channelBtns.splice(index, 1)
}

// 添加报名类型按钮
const addEntry = () => {
  const registerSection = configData.value.data.sections.find(s => s.id === 'register')
  registerSection.data.entryBtns.push({ type: "", icon: "" })
}

// 删除报名类型按钮
const removeEntry = (index) => {
  const registerSection = configData.value.data.sections.find(s => s.id === 'register')
  registerSection.data.entryBtns.splice(index, 1)
}

// 初始化加载配置
onMounted(() => {
  loadWebsiteConfig()
})
</script>

<style scoped lang="scss">
.register-entry-config {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding: 20px;
}

.header {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 100;

  h1 {
    margin: 0;
    color: #333;
    font-size: 24px;
  }
}

.header-actions {
  display: flex;
  gap: 12px;

  .btn {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .save-btn {
    background-color: #E6398B;
    color: white;

    &:hover:not(:disabled) {
      background-color: #d4287a;
    }
  }
}

.config-editor {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.config-section {
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  margin-bottom: 16px;
  overflow: hidden;

  &:last-child {
    margin-bottom: 0;
  }
}

.section-header {
  background-color: #fafafa;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;

  h2 {
    margin: 0;
    font-size: 18px;
    color: #333;
  }
}

.section-content {
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }

  label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }

  input[type="text"], textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    transition: border-color 0.3s;

    &:focus {
      border-color: #1890ff;
      outline: none;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
    }
  }

  textarea {
    min-height: 80px;
    resize: vertical;
  }
}

.channel-list {
  .channel-item {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;

    .channel-input {
      flex: 1;
    }

    .remove-btn {
      padding: 10px 15px;
      background-color: #ff4d4f;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;

      &:hover {
        background-color: #d9363e;
      }
    }
  }

  .add-btn {
    padding: 8px 16px;
    background-color: #1890ff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      background-color: #40a9ff;
    }
  }
}

.entry-item {
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 15px;

  .remove-entry-btn {
    padding: 6px 12px;
    background-color: #ff4d4f;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 10px;

    &:hover {
      background-color: #d9363e;
    }
  }
}

.add-btn {
  padding: 8px 16px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #40a9ff;
  }
}
</style>
